import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SurveySubmittedPage from "../Components/SurveySubmittedPage";
import MobileSurveySubmittedPage from "../Components/MobileSurveySubmittedPage";
import { CheckResponsiveContext } from "../../Context/CheckResponsiveContext";

function SurveySubmittedPageContainer() {
  const { isMobile } = useContext(CheckResponsiveContext);
  const { id } = useParams() as { id: string };
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (state?.status !== "completed") {
      navigate("/no-page-found");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleViewSubbmission = () => {
    navigate(`/assessment/${id}?viewSubmission=true`);
  };

  return (
    <>
      {!isMobile ? (
        <SurveySubmittedPage handleViewSubbmission={handleViewSubbmission} />
      ) : (
        <MobileSurveySubmittedPage
          handleViewSubbmission={handleViewSubbmission}
        />
      )}
    </>
  );
}
export default SurveySubmittedPageContainer;
